import { ShippingTypeEnum } from "../../../../../enums/ShippingTypeEnum";

export const optionsShippingType = [
  { value: ShippingTypeEnum.PAC, label: "Econômico" },
  { value: ShippingTypeEnum.SEDEX, label: "Expresso" },
];
